import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faCheck,
	faSync,
	faTimesCircle,
} from "@fortawesome/free-solid-svg-icons"
import { COLORS, modalStyles } from "../../../utilities/Constants"
import AppBtn from "../button/AppBtn"

const CustomModal = ({
	title,
	subtitle,
	onClose,
	buttons = [],
	children,
	showFooter = true,
	showCloseButton = true,
	maxWidth = null,
	// Nœud optionnel aligné à GAUCHE du footer (les boutons restent à droite).
	footerLeft = null,
	// Surcharge du style du body (ex. `overflow: hidden` quand le scroll doit
	// vivre dans une zone interne du contenu plutôt que sur le body entier).
	bodyStyle = null,
}) => (
	// Pas de fermeture au clic sur l'overlay (volontaire) : un missclick en
	// plein formulaire perdait toute la saisie. Fermeture par la croix ou les
	// boutons du footer uniquement.
	<div style={modalStyles.overlay} data-custom-modal="">
		<div
			style={
				maxWidth
					? { ...modalStyles.modal, maxWidth }
					: modalStyles.modal
			}
		>
			<div style={modalStyles.header}>
				<div>
					<div style={modalStyles.title}>{title}</div>
					{subtitle && (
						<div style={modalStyles.subtitle}>{subtitle}</div>
					)}
				</div>
				{showCloseButton && (
					<button style={modalStyles.closeBtn} onClick={onClose}>
						×
					</button>
				)}
			</div>
			{children && (
				<div
					style={
						bodyStyle
							? { ...modalStyles.body, ...bodyStyle }
							: modalStyles.body
					}
				>
					{children}
				</div>
			)}
			{showFooter && (
				<div style={modalStyles.footer}>
					{footerLeft && (
						<div style={{ marginRight: "auto", display: "flex" }}>
							{footerLeft}
						</div>
					)}
					{buttons.map((btnInfo, i) => (
						<AppBtn
							key={`btn_${i}`}
							title={btnInfo.title}
							styleName={btnInfo.styleName}
							onClick={btnInfo.onClick}
							disabled={btnInfo.disabled ?? false}
							loading={btnInfo.loading ?? false}
						/>
					))}
				</div>
			)}
		</div>
	</div>
)

export default CustomModal

export const SavingCustomModal = ({
	post,
	title = "Sauvegarde...",
	onClose = () => {},
	afterSavedChildren = null,
}) => {
	const effectiveTitle = post.error
		? "Erreur"
		: post.saved
			? "Sauvegarde terminée"
			: title
	return (
		<CustomModal
			title={effectiveTitle}
			onClose={onClose}
			showFooter={post.error || post.saved}
			showCloseButton={false}
			buttons={[
				{ title: "Fermer", styleName: "primary", onClick: onClose },
			]}
		>
			<div
				style={{
					flex: 1,
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					gap: 10,
					textAlign: "center",
				}}
			>
				{post.saving ? (
					<FontAwesomeIcon icon={faSync} spin />
				) : post.error ? (
					<>
						<FontAwesomeIcon
							icon={faTimesCircle}
							size="2x"
							style={{ color: COLORS.danger }}
						/>
						<div>
							{(post.error &&
								(post.error.message || post.error.msg)) ||
								"La sauvegarde a échoué."}
						</div>
					</>
				) : post.saved ? (
					afterSavedChildren ? (
						afterSavedChildren
					) : (
						<FontAwesomeIcon
							icon={faCheck}
							size="2x"
							style={{ color: COLORS.success }}
						/>
					)
				) : null}
			</div>
		</CustomModal>
	)
}

export const DeletingCustomModal = ({
	status,
	title = "Suppression...",
	onClose = () => {},
}) => {
	const effectiveTitle = status.error ? "Erreur" : title
	return (
		<CustomModal
			title={effectiveTitle}
			onClose={onClose}
			showFooter={status.error || status.deleted}
			showCloseButton={false}
			buttons={[
				{ styleName: "primary", onClick: onClose, title: "Fermer" },
			]}
		>
			<div
				style={{
					flex: 1,
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					gap: 10,
					textAlign: "center",
				}}
			>
				{status.deleting ? (
					<FontAwesomeIcon icon={faSync} spin />
				) : status.error ? (
					<>
						<FontAwesomeIcon
							icon={faTimesCircle}
							size="2x"
							style={{ color: COLORS.danger }}
						/>
						<div>
							{(status.error &&
								(status.error.message || status.error.msg)) ||
								"La suppression a échoué."}
						</div>
					</>
				) : status.deleted ? (
					<span>Suppression terminée</span>
				) : null}
			</div>
		</CustomModal>
	)
}

export const LoadingCustomModal = ({
	title = "Chargement...",
	onClose = () => {},
}) => {
	return (
		<CustomModal
			title={title}
			onClose={onClose}
			showFooter={false}
			showCloseButton={false}
		>
			<div
				style={{
					flex: 1,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<FontAwesomeIcon icon={faSync} spin />
			</div>
		</CustomModal>
	)
}
